import React from 'react';
import { Icons } from "../Components"
import { Button, Text } from "../Components/Themed"
import { useColors } from "../constants/useColors"
import type { GuideResponseProps } from '../types';
import { HelpApi } from './api';

type GuideButtonProps = {
    client_native_id:string,
    show_label?:boolean,
    label?:string,
    onError:() => void,
    onHelp:(guide:GuideResponseProps) => void
}

const GuideButton = ({ client_native_id, onError, onHelp, show_label, label }:GuideButtonProps) => {
    const Colors = useColors();
    const getGuide = async() => {
        HelpApi.setEnvironment();
        const guide_response = await HelpApi.getHelpByNativeId(client_native_id);
        if(!guide_response){ return onError() }
        return onHelp(guide_response);
    }
    return (
        <Button transparent style={{ padding:10, flexDirection:'row', alignItems:'center' }} onPress={() => getGuide()}>
            <Icons.AlertIcon size={18} color={Colors.text.warning} />
            {show_label ?
            <Text style={{ marginLeft:3 }} theme='warning'>{label ?? 'Need Help?'}</Text>
            :<></>}
        </Button>
    )
}

export default GuideButton